import { render, staticRenderFns } from "./RecommendationBlock.vue?vue&type=template&id=5e77f5fc&scoped=true"
import script from "./RecommendationBlock.vue?vue&type=script&lang=js"
export * from "./RecommendationBlock.vue?vue&type=script&lang=js"
import style0 from "./RecommendationBlock.vue?vue&type=style&index=0&id=5e77f5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77f5fc",
  null
  
)

export default component.exports